import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import download from '../../assets/download.svg';
import './PreviewModal.scss';
import close from '../../assets/close.svg';

export default function PreviewModal(props: any) {
    const [open, setOpen] = React.useState(false);
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        setOpen(true);
    }, []);

    React.useEffect(() => {
        if (props.url) {
            setTimeout(() => {
                window.document
                    .querySelector('#pdfPreview')
                    ?.addEventListener('previewError', previewError);
            }, 0);
        }
        return () => {
            window.document
                .querySelector('#pdfPreview')
                ?.removeEventListener('previewError', previewError);
        };
    }, [props.url]);

    const previewError = (event: any) => {
        setError(event?.detail || 'Something went wrong');
    };

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason === 'backdropClick') return;
        props.onClose();
    };

    const onDownload = async () => {
        if (props.url) {
            fetch(props.url).then((response) => {
                if (response.ok) {
                    return response.blob().then((myBlob) => {
                        myBlob = myBlob.slice(
                            0,
                            myBlob.size,
                            'application/pdf'
                        );
                        var objectURL = URL.createObjectURL(myBlob);
                        const link = document.createElement('a');
                        link.setAttribute('href', objectURL);
                        link.setAttribute('download', props.name);
                        link.setAttribute('type', 'application/pdf');
                        link.setAttribute('target', '_blank');
                        link.click();
                        link.remove();
                    });
                }
            });
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} className='preview-modal'>
            <div className='content'>
                <div className='close-btn cursor-pointer' onClick={handleClose}>
                    <img src={close} alt='' height={11} width={14} />
                </div>
                <div className='wrapper'>
                    <div className='card card-holder padding margin'>
                        <twintag-preview
                            id='pdfPreview'
                            extension='pdf'
                            item={props.url}
                        ></twintag-preview>
                        {error && <div className='error-wrapper'>{error}</div>}
                    </div>
                    <div className='action-container'>
                        <button className='primary' onClick={onDownload}>
                            {props.downloadText}
                            <img src={download} alt='' />
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
